import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { APP_INITIALIZER, ErrorHandler, LOCALE_ID, NgModule } from '@angular/core';
import { HTTP_INTERCEPTORS, HttpClient, HttpClientModule } from '@angular/common/http';
import { IonicApp, IonicModule } from 'ionic-angular';
import { MyApp } from './app.component';
import { StatusBar } from '@ionic-native/status-bar';
import { SplashScreen } from '@ionic-native/splash-screen';
import { TimepickerModule } from 'ngx-bootstrap/timepicker';
import { SetupService } from '../services/setup/setup.service';
import { AppConfig } from './app.config';
import { DbContext } from '../services/data/dbcontext.service';
import { OperationService } from '../services/operations/operation/operation.service';
import { DropDownsModule } from '@progress/kendo-angular-dropdowns';
import { GridModule } from '@progress/kendo-angular-grid';
import { FoundationModule } from '../_foundation/foundation.module';
import { NavHelperService } from '../services/nav/nav-helper.service';
import { OperationValidatorService } from '../services/operations/operation-validator.service';
import { VesselService } from '../services/vessel/vessel.service';
import { SetupValidatorService } from '../services/setup/setup-validator.service';
import { SearchService } from '../services/search/search.service';
import { DateService } from '../services/date/date.service';
import { OperationTimeService } from '../services/operations/operation-time/operation-time.service';
import 'rxjs/add/operator/mergeMap';
import 'rxjs/add/operator/switchMap';
import 'rxjs/add/observable/of';
import { DailyLogService } from '../services/daily-log/daily-log.service';
import { DailyLogEntriesService } from '../services/daily-log/daily-log-entries/daily-log-entries.service';
import { CommonModule } from '@angular/common';
import { DateParserService } from '../services/daily-log/daily-log-time/date-parser-service';
import { TextMaskModule } from 'angular2-text-mask';
// tslint:disable-next-line:max-line-length
import { ContractualOperationValidatorService } from '../services/operations/operation-validation/contractual-operation-validator-service/contractual-operation-validator.service';
// tslint:disable-next-line:max-line-length
import { ConcurrentOperationValidatorService } from '../services/operations/operation-validation/concurrent-operation-validator-service/concurrent-operation-validator.service';
import { DelayService } from '../services/delay/delay-service/delay.service';
import { RecordOperationLinkService } from '../services/record-operation-link/record-operation-link.service';
import { MultipleDayService } from '../services/mutiple-day/multiple-day.service';
import { DatePickerModule } from '@progress/kendo-angular-dateinputs';
import { CommentsService } from '../services/comments/comments.service';
import { StepService } from '../services/step/step.service';
import { DailyLogTimeService } from '../services/daily-log/daily-log-time/daily-log-time-service';
import { OperationSaveService } from '../services/operations/operation-save/operation-save.service';
import { TransitingSaveService } from '../services/operations/transiting-save/transiting-save.service';
import { DateChangeRecordService } from '../services/daily-log/date-change-record/date-change-record.service';
import { DailyLogValidationService } from '../services/daily-log/daily-log-validation/daily-log-validation.service';
import { DailyProgressReportService } from '../services/daily-progress-report/daily-progress-report.service';
import { AppDataSyncService } from '../services/app-data-sync/app-data-sync.service';
import { AuthService } from '../_foundation/services/auth/auth.service';
import { UserService } from '../services/user/user.service';
import { LockedDayService } from '../services/locked-day/locked-day.service';
import { AuthInterceptor } from '../_foundation/utils/auth.interceptor';
import { RouterModule } from '@angular/router';
import { LocalSaveService } from '../services/local/local-save.service';
import { LocalOperationSaveService } from '../services/local/operation/local-operation-save.service';
import { CompleteDayService } from '../services/complete-day/complete-day.service';
import { TimeZoneService } from '../services/time-zone/time-zone.service';
import { WeatherReadingsService } from '../services/weather-readings/weather-readings.service';
import { SafetyService } from '../services/safety/safety.service';
import { WeatherLogValidationService } from '../services/weather-readings/weather-log-validation.service';
import { ConsumablesService } from '../services/consumables/consumables.service';
import { VesselCrewService } from '../services/vessel-crew/vessel-crew.service';
import { LayoutModule } from '@progress/kendo-angular-layout';
import { ValidationService } from '../services/validation/validation.service';
// tslint:disable-next-line:max-line-length
import { JackingActivityService } from '../services/jacking-activity/jacking-activity.service';
import { JackingActivityValidationService } from '../services/jacking-activity/jacking-activity-validation.service';
import { MetadataService } from '../services/metadata/metadata-service.service';
import { DailyLegLoadService } from '../services/daily-leg-loads/daily-leg-load.service';
import { DailyLegLoadValidationService } from '../services/daily-leg-loads/daily-leg-load-validation.service';
import { PermissionsService } from '../services/permissions/permissions.service';
import { DefaultPage } from '../pages/default/default-page/default-page';
// tslint:disable-next-line:max-line-length
import { DailyObservationService } from '../services/daily-observation/daily-observation.service';
import { StageService } from '../services/stage/stage.service';
// tslint:disable-next-line:max-line-length
import { FieldPositioningService } from '../services/field-positioning/field-positioning.service';
import { PipesModule } from '../pipes/pipes.module';
import { ChartsModule } from 'ng2-charts-x';
import { DailyLegLoadGraphService } from '../services/daily-leg-loads/daily-leg-load-graph.service';
import 'chartjs-plugin-zoom';
import 'hammerjs';
import { FoundationErrorHandler } from '../_foundation/utils/error-handler';
import { NgIdleModule } from '@ng-idle/core';
import { IdleService } from '../services/idle/idle.service';
import { OnSiteMovementService } from '../services/on-site-movement/on-site-movement.service';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { SharedModule } from '../pages/shared/shared.module';
import { CurrentDayService } from '../services/date/current-day.service';
import { VoyageLogService } from '../services/voyage-log/voyage-log.service';
import { CyclesService } from '../services/cycles/cycles.service';
import { MorningMinutesService } from '../services/morning-minutes/morning-minutes.service';
import { MorningMinutesReportService } from '../services/morning-minutes/morning-minutes-report.service';
import { JackingActivityReportService } from '../services/jacking-activity/jacking-activity-report.service';
import { ImplementerService } from '../services/implementer/implementer.service';
import { CalendarModule, DateAdapter } from 'angular-calendar';
import { ChangeHistoryService } from '../services/change-history/change-history-service';
import { ArchwizardModule } from 'angular-archwizard';
import { LockedDayPermissionService } from '../services/implementer/locked-day-permission.service';
import { DprAttachmentFileUploadService } from '../services/dpr-attachments/dpr-attachments-file-upload.service';
import { TransitService } from '../services/transit/transit.service';
import { ImplementerDateService } from '../services/implementer/implementer-date.service';
import { ErrorsPageModule } from '../pages/shared/components/errors-page/errors-page.module';
import { OperationDetailsLocationSelectPageModule } from '../pages/operations/operation-details-location-select/operation-details-location-select.module';
import { LoginPageModule } from '../pages/auth/login/login.module';
import { NavRootPageModule } from '../pages/nav/nav-root/nav-root.module';
import { NavMainMenuPageModule } from '../pages/nav/nav-menus/nav-main-menu/nav-main-menu.module';
import { DefaultPageModule } from '../pages/default/default-page/default-page.module';
import { DailyLogPageModule } from '../pages/daily-log/daily-log/daily-log.module';
import { NavDailyLogSubmenuPageModule } from '../pages/nav/nav-menus/nav-daily-log-submenu/nav-daily-log-submenu.module';
import { SelectOperationPageModule } from '../pages/operations/select-operation/select-operation.module';
import { CommentEditPageModule } from '../pages/comments/comment-edit/comment-edit.module';
import { DailyProgressReportPreviewPageModule } from '../pages/daily-progress-report/daily-progress-report-preview/daily-progress-report-preview.module';
import { OperationSplitPageModule } from '../pages/operations/operation-split/operation-split.module';
import { ChangeHistoryPageModule } from '../pages/change-history/change-history/change-history.module';
import { ConsumableEditPageModule } from '../pages/DPR Pages/consumables/consumable-edit/consumable-edit.module';
import { DprAttachmentsEditPageModule } from '../pages/DPR Pages/dpr-attachments/dpr-attachments-edit/dpr-attachments-edit.module';
import { DailyLegLoadEventsPageModule } from '../pages/daily-leg-loads/daily-leg-load-events/daily-leg-load-events.module';
import { DailyLegLoadGraphPageModule } from '../pages/daily-leg-loads/daily-leg-load-graph/daily-leg-load-graph.module';
import { DailyLegLoadTotalExtensionsPageModule } from '../pages/daily-leg-loads/daily-leg-load-total-extensions/daily-leg-load-total-extensions.module';
import { DailyLegLoadsLogPageModule } from '../pages/daily-leg-loads/daily-leg-loads-log/daily-leg-loads-log.module';
import { DailyLegLoadManageRecordingsPageModule } from '../pages/daily-leg-loads/daily-leg-load-manage-readings/daily-leg-load-manage-readings.module';
import { DailyLogModalPageModule } from '../pages/daily-log/daily-log-modal/daily-log-modal.module';
import { DailyLogSummaryPageModule } from '../pages/daily-log/daily-log-summary/daily-log-summary.module';
import { LogEventsPageModule } from '../pages/daily-log/log-events/log-events.module';
import { DailyObservationEditPageModule } from '../pages/DPR Pages/daily-observations/daily-observations/daily-observation-edit.module';
import { FieldPositioningCompletePageModule } from '../pages/field-positioning/field-positioning-complete/field-positioning-complete.module';
import { FieldPositioningEditPageModule } from '../pages/field-positioning/field-positioning-edit/field-positioning-edit.module';
import { ImplementerEmptyStatePageModule } from '../pages/implementer/implementer-empty-state/implementer-empty-state/implementer-empty-state-page.module';
import { ImplementerCancelPageModule } from '../pages/implementer/implementer-cancel/implementer-cancel/implementer-cancel-page.module';
import { ImplementerInitialiserPageModule } from '../pages/implementer/implementer-initialiser/implementer-initialiser.module';
import { ImplementerMergePageModule } from '../pages/implementer/implementer-merge/implementer-merge/implementer-merge-page.module';
import { ImplementerNavigatorPageModule } from '../pages/implementer/implementer-navigator/implementer-navigator.module';
import { JackingActivityEditCancelPageModule } from '../pages/jacking-activities/v1/jacking-activity-edit-cancel/jacking-activity-edit-cancel.module';
import { JackingActivityEditCompletePageModule } from '../pages/jacking-activities/v1/jacking-activity-edit-complete/jacking-activity-edit-complete.module';
import { JackingActivityEditPageModule } from '../pages/jacking-activities/v1/jacking-activity-edit/jacking-activity-edit.module';
import { MorningMinutesComponentModule } from '../pages/morning-minutes/morning-minutes-component/morning-minutes-component.module';
import { MorningMinutesReportPreviewPageModule } from '../pages/morning-minutes/morning-minutes-report-preview/morning-minutes-report-preview.module';
import { MorningMinutesPageModule } from '../pages/morning-minutes/morning-minutes/morning-minutes.module';
import { OnSiteMovementEditCompletePageModule } from '../pages/on-site-movement/on-site-movement-edit-complete/on-site-movement-edit-complete.module';
import { OnSiteMovementEditPageModule } from '../pages/on-site-movement/on-site-movement-edit/on-site-movement-edit.module';
import { AffectedOperationsPageModule } from '../pages/operations/affected-operations/affected-operations.module';
import { OperationDetailsEditLocationSelectPageModule } from '../pages/operations/operation-details-edit-location-select/operation-details-edit-location-select.module';
import { OperationDetailsEditPageModule } from '../pages/operations/operation-details-edit/operation-details-edit.module';
import { OperationGenericCommentsPageModule } from '../pages/operations/operation-generic-comments/operation-generic-comments.module';
import { StepCommentsPageModule } from '../pages/operations/step-comments/step-comments.module';
import { OperationCommentsPageModule } from '../pages/operations/operation-comments/operation-comments.module';
import { SafetyEditPageModule } from '../pages/DPR Pages/safety/safety-edit/safety-edit.module';
import { SafetyReportEditPageModule } from '../pages/DPR Pages/safety/safety-report-edit/safety-report-edit.module';
import { ConfigureProjectPageModule } from '../pages/setup/configure-project/configure-project.module';
import { TimezoneChangePageModule } from '../pages/setup/timezone-change/timezone-change.module';
import { ContractualHierarchyPageModule } from '../pages/validation/contractual-hierarchy/contractual-hierarchy.module';
import { MultiDayPageModule } from '../pages/validation/multi-day/multi-day.module';
import { VoyageLogPageModule } from '../pages/voyage-log/voyage-log/voyage-log.module';
import { WeatherEventsPageModule } from '../pages/weather-readings/weather-events/weather-events.module';
import { WeatherLogPageModule } from '../pages/weather-readings/weather-log/weather-log.module';
import { WeatherReadingCreatePageModule } from '../pages/weather-readings/weather-reading-create/weather-reading-create.module';
import { WeatherRemarkEditPageModule } from '../pages/weather-readings/weather-remark-edit/weather-remark-edit.module';
import { OpenEndedPageModule } from '../pages/validation/open-ended/open-ended.module';
import { OperationDetailsPageModule } from '../pages/operations/operation-details/operation-details.module';
import { NavDprSectionsSubmenuPageModule } from '../pages/nav/nav-menus/nav-dpr-sections-submenu/nav-dpr-sections-submenu.module';
import { NavSettingsSubmenuPageModule } from '../pages/nav/nav-menus/nav-settings-submenu/nav-settings-submenu.module';
import { CyclesPageModule } from '../pages/cycles/cycles.module';
import { VesselCrewEditModule } from '../pages/DPR Pages/vessel-crew/vessel-crew-edit/vessel-crew-edit.module';
import { VesselCrewOvertimeEditModule } from '../pages/DPR Pages/vessel-crew/vessel-crew-overtime-edit/vessel-crew-overtime-edit.module';
import { ResetPasscodeModule } from '../pages/auth/reset-passcode/reset-passcode.module';
import { DirectivesModule } from '../directives/directives.module';
import { LuxonDateAdapter } from '../pages/shared/components/pt-luxon-date-picker/LuxonDateAdapter';
import { adapterFactory } from 'angular-calendar/date-adapters/date-fns';
import { SetupDataService } from '../services/setup/setup-data.service';
import { SignalRService } from '../services/signalR/signalRService';
import {ClientInstanceService} from '../services/signalR/client-instance.service';
import {JackingThreeWayMergeService} from '../services/jacking-v2/jacking-three-way-merge.service';
import {JackingMergeModalComponentModule} from '../pages/jacking-activities/v2/components/jacking-merge-modal/jacking-merge-modal.component.module';
import { DailyLegLoadFrequencyService } from '../services/daily-leg-loads/daily-leg-load-frequency.service';
import { DailyLegLoadStandaloneService } from '../services/daily-leg-loads/daily-leg-load-standalone.service';
import {
  ProjectDetailPhaseGridPageModule
} from '../pages/setup/project-details/project-detail-phase-grid/project-detail-phase-grid.module';
import { PtKendoModule } from '../_foundation/kendo/modules/pt.kendo.module';
import {
  ProjectDetailStageGridPageModule
} from '../pages/setup/project-details/project-detail-stage-grid/project-detail-stage-grid.module';
import {
  ProjectDetailLocationGridPageModule
} from '../pages/setup/project-details/project-detail-location-grid/project-detail-location-grid.module';
import {
  ProjectDetailCoaGridPageModule
} from '../pages/setup/project-details/project-detail-coa-grid/project-detail-coa-grid.module';
import {
  JackingActivityFileUploadModalComponentModule
} from '../pages/jacking-activities/v1/jacking-activity-file-upload-modal/jacking-activity-file-upload-modal.module';
import { JackingActivityFileUploadService } from '../services/jacking-activity/jacking-activity-file-upload.service';
import {
  FieldPositioningOutstandingPageModule
} from '../pages/validation/field-positioning-outstanding/field-positioning-outstanding.module';
import {
  JackingRobFuelFiguresPageModule
} from '../pages/DPR Pages/jacking-rob-fuel-figures/jacking-rob-fuel-figures/jacking-rob-fuel-figures.module';
import { JackingActivityRobFigureService } from '../services/jacking-activity/jacking-activity-rob-figure.service';
import {
  RobFigureOutstandingPageModule
} from '../pages/validation/rob-figure-outstanding/rob-figure-outstanding.module';
import {
  WeatherLogManageRecordingsPageModule
} from '../pages/weather-readings/weather-log-manage-readings/weather-log-manage-readings.module';
import {
  WeatherLogAdditionalReadingService
} from '../services/weather-readings/weather-log-additional-reading.service';
import {JackingV2Service} from '../services/jacking-v2/jacking-v2.service';
import {
  JackingActivityEditV2PageModule
} from '../pages/jacking-activities/v2/jacking-activity-edit-v2/jacking-activity-edit-v2.module';
import {VesselContextService} from '../services/vessel/vessel-context.service';
import {JackingActivitiesRouterPageModule} from '../pages/jacking-activities/jacking-activities-router/jacking-activities-router-page.module';
import {DirtyTrackingService} from '../services/jacking-v2/dirty-tracking.service';
import {JackingV2FileDownloadService} from '../services/jacking-v2/jacking-v2-file-download.service';
import {JackingCancelModalComponentModule} from '../pages/jacking-activities/v2/components/jacking-cancel-modal/jacking-cancel-modal.component.module';
import {JackingCompleteModalComponentModule} from '../pages/jacking-activities/v2/components/jacking-complete-modal/jacking-complete-modal.component.module';
import { SupportModule } from '../pages/support/support.module';
import { SupportContextService } from '../services/support/support-context.service';
import { SupportVideoCatalogService } from '../services/support/support-video-catalog.service';
import { ServiceDeskTicketService } from '../services/support/service-desk-ticket.service';
import { SupportVideoPlayerPageModule } from '../pages/support/support-video-player/support-video-player.module';

export function initializeApp(appConfig: AppConfig) {
  return () => appConfig.load();
}

const SERVICES: any[] = [
  DbContext,
  VesselContextService,
  SetupService,
  SetupDataService,
  SetupValidatorService,
  OperationService,
  VesselService,
  OperationValidatorService,
  LockedDayService,
  {
    provide: NavHelperService,
    deps: [HttpClient],
    useFactory: (http: HttpClient) => new NavHelperService(http, DefaultPage)
  },
  ContractualOperationValidatorService,
  ConcurrentOperationValidatorService,
  MultipleDayService,
  DelayService,
  RecordOperationLinkService,
  SafetyService,
  SearchService,
  DateService,
  OperationTimeService,
  AuthService,
  DailyLogService,
  DailyLogEntriesService,
  DailyLogTimeService,
  DateParserService,
  OperationSaveService,
  StepService,
  CommentsService,
  TransitingSaveService,
  DateChangeRecordService,
  DailyLogValidationService,
  DailyProgressReportService,
  AppDataSyncService,
  UserService,
  LocalSaveService,
  LocalOperationSaveService,
  CompleteDayService,
  TimeZoneService,
  WeatherReadingsService,
  WeatherLogValidationService,
  WeatherLogAdditionalReadingService,
  ConsumablesService,
  VesselCrewService,
  ValidationService,
  JackingActivityService,
  JackingV2Service,
  JackingV2FileDownloadService,
  DirtyTrackingService,
  JackingActivityValidationService,
  JackingActivityReportService,
  JackingActivityFileUploadService,
  JackingActivityRobFigureService,
  MetadataService,
  DailyLegLoadService,
  DailyLegLoadFrequencyService,
  DailyLegLoadStandaloneService,
  DailyLegLoadValidationService,
  DailyLegLoadGraphService,
  PermissionsService,
  DprAttachmentFileUploadService,
  DailyObservationService,
  StageService,
  FieldPositioningService,
  OnSiteMovementService,
  CurrentDayService,
  IdleService,
  VoyageLogService,
  CyclesService,
  MorningMinutesService,
  MorningMinutesReportService,
  ImplementerService,
  ChangeHistoryService,
  LockedDayPermissionService,
  TransitService,
  ImplementerDateService,
  SignalRService,
  ClientInstanceService,
  JackingThreeWayMergeService,
  SupportContextService,
  SupportVideoCatalogService,
  ServiceDeskTicketService
];

@NgModule({
  declarations: [MyApp],
  imports: [
    DirectivesModule,
    BrowserModule,
    BrowserAnimationsModule,
    IonicModule.forRoot(MyApp),
    RouterModule.forRoot([]),
    HttpClientModule,
    TimepickerModule.forRoot(),
    GridModule,
    DropDownsModule,
    PtKendoModule,
    FoundationModule,
    CommonModule,
    TextMaskModule,
    DatePickerModule,
    LayoutModule,
    PipesModule,
    ChartsModule,
    PdfViewerModule,
    SharedModule,
    ErrorsPageModule,
    LoginPageModule,
    ResetPasscodeModule,
    NgIdleModule.forRoot(),
    CalendarModule.forRoot({
      provide: DateAdapter,
      useFactory: adapterFactory,
    }),
    ArchwizardModule,
    NavRootPageModule,
    NavMainMenuPageModule,
    NavDailyLogSubmenuPageModule,
    NavDprSectionsSubmenuPageModule,
    NavSettingsSubmenuPageModule,
    CyclesPageModule,
    DefaultPageModule,
    OperationDetailsLocationSelectPageModule,
    DailyLogPageModule,
    SelectOperationPageModule,
    CommentEditPageModule,
    DailyProgressReportPreviewPageModule,
    OperationSplitPageModule,
    ChangeHistoryPageModule,
    ConsumableEditPageModule,
    DailyLegLoadEventsPageModule,
    DailyLegLoadGraphPageModule,
    DailyLegLoadTotalExtensionsPageModule,
    DailyLegLoadsLogPageModule,
    DailyLegLoadManageRecordingsPageModule,
    DailyLogModalPageModule,
    DailyLogSummaryPageModule,
    LogEventsPageModule,
    DailyObservationEditPageModule,
    FieldPositioningCompletePageModule,
    FieldPositioningEditPageModule,
    JackingRobFuelFiguresPageModule,
    FieldPositioningOutstandingPageModule,
    RobFigureOutstandingPageModule,
    ImplementerEmptyStatePageModule,
    ImplementerCancelPageModule,
    ImplementerInitialiserPageModule,
    ImplementerMergePageModule,
    ImplementerNavigatorPageModule,
    JackingActivityEditCancelPageModule,
    JackingActivityEditCompletePageModule,
    JackingActivityEditPageModule,
    JackingActivityEditV2PageModule,
    JackingCancelModalComponentModule,
    JackingCompleteModalComponentModule,
    JackingMergeModalComponentModule,
    SupportModule,
    SupportVideoPlayerPageModule,
    MorningMinutesComponentModule,
    MorningMinutesReportPreviewPageModule,
    MorningMinutesPageModule,
    OperationCommentsPageModule,
    StepCommentsPageModule,
    OnSiteMovementEditCompletePageModule,
    OnSiteMovementEditPageModule,
    AffectedOperationsPageModule,
    OperationDetailsPageModule,
    OperationDetailsEditLocationSelectPageModule,
    OperationDetailsEditPageModule,
    OperationGenericCommentsPageModule,
    OperationCommentsPageModule,
    StepCommentsPageModule,
    SafetyEditPageModule,
    SafetyReportEditPageModule,
    ConfigureProjectPageModule,
    TimezoneChangePageModule,
    DprAttachmentsEditPageModule,
    ContractualHierarchyPageModule,
    OpenEndedPageModule,
    MultiDayPageModule,
    VesselCrewEditModule,
    VesselCrewOvertimeEditModule,
    VoyageLogPageModule,
    WeatherEventsPageModule,
    WeatherLogPageModule,
    WeatherReadingCreatePageModule,
    WeatherRemarkEditPageModule,
    WeatherLogManageRecordingsPageModule,
    ProjectDetailPhaseGridPageModule,
    ProjectDetailStageGridPageModule,
    ProjectDetailLocationGridPageModule,
    ProjectDetailCoaGridPageModule,
    JackingActivityFileUploadModalComponentModule,
    JackingActivitiesRouterPageModule
  ],
  providers: [
    AppConfig,
    {provide: APP_INITIALIZER, useFactory: initializeApp, deps: [AppConfig], multi: true},
    {provide: LOCALE_ID, useValue: 'en-GB'},
    {provide: ErrorHandler, useClass: FoundationErrorHandler},
    StatusBar,
    SplashScreen,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true
    },
    SERVICES,
    DirectivesModule,
    PtKendoModule,
    LuxonDateAdapter
  ],
  bootstrap: [IonicApp],
  exports: [
  ],
  entryComponents: [MyApp]
})
export class AppModule {
}



// WEBPACK FOOTER //
// ./src/app/app.module.ts